export default __webpack_public_path__ + "static/media/notification-filled.9e782ea5.svg";